import { Injectable, inject } from '@angular/core';
import { CareType } from '@models/common/care-type.model';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GeneralFiltersService {
  api = inject(CommonVerbsApiService);

  getCaretypes(corporationId: string): Observable<CareType[]> {
    return this.api.get<CareType[]>(`corporations/${corporationId}/care-types`);
  }
}
